import React, { useState } from "react";
import GenericTableHeader from "./GenericTableHeader";
import GenericTableRow from "./GenericTableRow";
import "./ResizableDraggableTable.css";
import GenericOverviewSideCard from "../GenericOverviewSideCard";
import SideCardHorizntalTabComp from "../sideCardHorizontalTabs/SideCardHorizntalTabComp";




const ResizableDraggableTable = ({initialColumns,tabData,sideCardTabConfig,showMoreModal, setShowMoreModal,titleForSideCard=null,activeTab, setActiveTab,loading,disableHeader=false}) => {
  // console.log("ResizableDraggableTable",activeTab,setActiveTab)
  const [columns, setColumns] = useState(initialColumns);

  const handleResize = (index, e) => {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = columns[index].width;

    const onMouseMove = (e) => {
      const newWidth = Math.max(50, startWidth + e.clientX - startX);
      setColumns((cols) => {
        const newCols = [...cols];
        newCols[index] = { ...newCols[index], width: newWidth };
        return newCols;
      });
    };

    const onMouseUp = () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };

  return (
    <>
      <table className="custom-resizable-table">
        <thead>
          <tr className="custom-resizable-table-header">
           {!disableHeader && <GenericTableHeader columns={columns} onResize={handleResize} />}
          </tr>
        </thead>
        <tbody>
          {!loading ? (
            tabData.map((row, idx) => (
              <GenericTableRow key={idx} row={row} columns={columns} />
            ))
          ) : (
            [...Array(10)].map((_, rowIdx) => (
              <tr key={`skeleton-${rowIdx}`} className="resize-table-skeleton-row">
                {columns.map((col, colIdx) => (
                  <td key={`skeleton-cell-${rowIdx}-${colIdx}`} style={{ width: col.width }}>
                    <div className="resize-table-skeleton-cell" />
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>


      </table>

      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={titleForSideCard}
        comp={<SideCardHorizntalTabComp tabConfig={sideCardTabConfig} setShowMoreModal={setShowMoreModal} activeTab={activeTab} setActiveTab={setActiveTab}/>}
        disableXbtn
      />
    </>
  );
};

export default ResizableDraggableTable;
